import { render, staticRenderFns } from "./UnderConstruccion.vue?vue&type=template&id=1588808a"
import script from "./UnderConstruccion.vue?vue&type=script&lang=js"
export * from "./UnderConstruccion.vue?vue&type=script&lang=js"
import style0 from "./UnderConstruccion.vue?vue&type=style&index=0&id=1588808a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports